// External modules
import PropTypes from 'prop-types';
import React from 'react';

import {
  AppBar,
  Button,
  Drawer,
  Hidden,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from '@material-ui/core';

// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuIcon from '@material-ui/icons/Menu';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import Tooltip from '@material-ui/core/Tooltip';

// Internal modules

import styles from './Navigation.module.scss';

function Navigation({ authProperties, navigationProperties, isLabelHidden = false }) {
  const [isMobileAndOpened, setIsMobileAndOpened] = React.useState(false);
  const [hover, setHover] = React.useState(false);
  const [hoverText, setHoverText] = React.useState('');

  if (!authProperties || !navigationProperties) return;

  function onChangeMobileNavigation() {
    setIsMobileAndOpened(!isMobileAndOpened);
  }

  function onChangeNavigationItem(navigationItem, isMobile) {
    if (isMobile) onChangeMobileNavigation();

    const { onChangeNavigationItemFunc } = navigationProperties;
    if (onChangeNavigationItemFunc) onChangeNavigationItemFunc(navigationItem);
  }

  function onLogOut() {
    const { onChangeLoggedInUserFunc, onChangeUserFunc } = authProperties;
    if (!onChangeLoggedInUserFunc || !onChangeUserFunc) return;

    onChangeLoggedInUserFunc(null);
    onChangeUserFunc(null);
  }

  function onOpenNewURLWindow(url) {
    window.open(url);
  }

  function renderNavigationItem(navigationItem, navigationProperties, isMobile) {
    if (!navigationProperties) return;

    const { selectedNavigationItem } = navigationProperties;

    let className;
    let isSelected = false;
    if (selectedNavigationItem && selectedNavigationItem.text === navigationItem.text) {
      className = styles.selected;
      isSelected = true;
    }
    if(hover && hoverText && hoverText === navigationItem.text){
      className = styles.selected;
    }

    const IconComponent = navigationItem.icon;

    return (
      <Tooltip title={navigationItem.text} placement="right" classes={{ tooltip: styles.navigationTooltip, arrow: styles.navigationPopperArrow }}         key={navigationItem.text}
      arrow>
      <ListItem
        button
        key={navigationItem.text}
        onClick={() => onChangeNavigationItem(navigationItem, isMobile)}
        selected={isSelected}
        className={className}
        onMouseEnter={(e)=>{
          setHover(true);
          setHoverText(e.currentTarget.querySelector('.MuiListItemIcon-root').getAttribute('label'));
        }}
        onMouseLeave={()=>{
          setHover(false);
          setHoverText('');
        }}
        style={{
          padding: !isLabelHidden ? '8px 16px' : '',
          justifyContent : isLabelHidden ? 'center' : ''
        }}
      >
        <ListItemIcon label={navigationItem.text}
        style={{
          minWidth: !isLabelHidden ? '36px' : '0px',
          padding: isLabelHidden ? '8px 0' : '',

        }}>
          <IconComponent />
        </ListItemIcon>
        {!isLabelHidden && (
          <ListItemText primary={navigationItem.text} />
        )}

      </ListItem>
      </Tooltip>
    );
  }

  function renderNavigationItems(navigationProperties, isMobile) {
    const { navigationItems } = navigationProperties;
    let navigationItemComponents = [];
    navigationItems.forEach((ni) => {
      navigationItemComponents.push(renderNavigationItem(ni, navigationProperties, isMobile));
    });

    return <List className={styles.navigationItems}>{navigationItemComponents}</List>;
  }

  function renderDesktopNavigationReferenceItem(referenceItem) {
    const { text, url } = referenceItem;
    return (
      <Button key={text} className={styles.referenceItem} onClick={() => onOpenNewURLWindow(url)}>
        {text}
      </Button>
    );
  }

  // function renderGodMode(onChangeGodModeTextFunc, onClickGodModeFunc) {
  //   return (
  //     <Paper
  //       style={{
  //         backgroundColor: 'transparent',
  //         textAlign: 'center',
  //       }}
  //     >
  //       <InputBase
  //         name="inputField"
  //         onChange={(e) => onChangeGodModeTextFunc(e.target.value)}
  //         placeholder="Provider Id"
  //         style={{
  //           color: 'white',
  //         }}
  //       />
  //       <IconButton aria-label="search" onClick={onClickGodModeFunc}>
  //         <SearchIcon />
  //       </IconButton>
  //     </Paper>
  //   );
  // }

  function renderDesktopNavigationFooterPanel(authProperties, navigationProperties) {
    const { loggedInUser } = authProperties;
    // const { enableGodMode, onChangeGodModeTextFunc, onClickGodModeFunc } = navigationProperties;
    if (!loggedInUser) return;

    return (
      <Tooltip title={'Log Out'} classes={{ tooltip: styles.navigationTooltip, arrow: styles.navigationPopperArrow }} placement="right" arrow>
        <span>
          {/* {enableGodMode && onChangeGodModeTextFunc && onClickGodModeFunc
            ? renderGodMode(onChangeGodModeTextFunc, onClickGodModeFunc)
            : null} */}
        <List className={styles.footerList}>
          <ListItem
            button
            onClick={onLogOut}
            style={{
              padding: !isLabelHidden ? '8px 16px' : '',
              justifyContent : isLabelHidden ? 'center' : ''
            }}
          >
            <ListItemIcon style={{
              minWidth: !isLabelHidden ? '56px' : '0px',
              padding: isLabelHidden ? '23px 0' : '',
            }}>
              <ExitToAppIcon
                  style={{
                    color: 'white',
                  }}
                />
            </ListItemIcon>
            {!isLabelHidden && (
              <ListItemText primary={'Log Out'} />
            )}
          </ListItem>
        </List>
        </span>
    </Tooltip>
    );
  }

  function renderDesktopNavigationHeaderPanel(navigationProperties) {
    const { logo, referenceItems, title } = navigationProperties;
    if (!referenceItems) return;

    const LogoComponent = logo;

    let referenceItemComponents = [];
    referenceItems.forEach((ri) => {
      referenceItemComponents.push(renderDesktopNavigationReferenceItem(ri));
    });

    return (
      <Tooltip title="Home" classes={{ tooltip: styles.navigationTooltip, arrow: styles.navigationPopperArrow }} placement="right" arrow>
      <div className={styles.logoPanel} style={{
        justifyContent: isLabelHidden ? 'center' : ''
      }}>
        <div>
        <LogoComponent className={styles.logo} />
        </div>
        {!isLabelHidden && (
          <div className={styles.logoTitle}>{title}</div>
        )}

      </div>
      </Tooltip>
      // <Accordion className={styles.logoPanel} elevation={0}>
      //   <AccordionSummary
      //     expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
      //     classes={{
      //       root: styles.logoSummaryRoot,
      //       content: styles.logoSummaryContent,
      //     }}
      //   >
      //     <LogoComponent className={styles.logo} />
      //     <span className={styles.logoTitle}>{title}</span>
      //   </AccordionSummary>
      //   <AccordionDetails className={styles.logoDetails}>
      //     {referenceItemComponents}
      //   </AccordionDetails>
      // </Accordion>
    );
  }

  function renderDesktopNavigation(authProperties, navigationProperties) {
    return (
      <Hidden smDown implementation="css">
        <Drawer
          className={styles.drawer}
          classes={{
            paper: isLabelHidden ? styles.drawerPaperLabelHidden : styles.drawerPaper,
          }}
          variant="permanent"
          open
        >
          {renderDesktopNavigationHeaderPanel(navigationProperties)}
          {renderNavigationItems(navigationProperties)}
          {renderDesktopNavigationFooterPanel(authProperties, navigationProperties)}
        </Drawer>
      </Hidden>
    );
  }

  function renderMobileNavigationFooterPanel(authProperties) {
    const { loggedInUser } = authProperties;
    if (!loggedInUser) return;

    return (

      <Tooltip title={'Log Out'} classes={{ tooltip: styles.navigationTooltip, arrow: styles.navigationPopperArrow }} placement="right" arrow>
        <span>
        <List className={styles.footerList}>
          <ListItem
            button
            onClick={onLogOut}
            style={{
              padding: !isLabelHidden ? '8px 16px' : '',
              justifyContent : isLabelHidden ? 'center' : ''
            }}
          >
            <ListItemIcon style={{
              minWidth: !isLabelHidden ? '56px' : '0px',
              padding: isLabelHidden ? '23px 0' : '',
            }}>
              <ExitToAppIcon
                  style={{
                    color: 'white',
                  }}
                />
            </ListItemIcon>
            {!isLabelHidden && (
              <ListItemText primary={'Log Out'} />
            )}
          </ListItem>
        </List>
        </span>
    </Tooltip>

      // <Accordion className={styles.footerPanel}>
      //   <AccordionSummary
      //     expandIcon={<ExpandLessIcon style={{ color: 'white' }} />}
      //     classes={{
      //       root: styles.footerSummaryRoot,
      //       content: styles.footerSummaryContent,
      //     }}
      //   >
      //     <PersonIcon
      //       style={{
      //         color: 'white',
      //       }}
      //     />
      //     <span
      //       style={{
      //         maxWidth: '120px',
      //         whiteSpace: 'nowrap',
      //         overflow: 'hidden',
      //         textOverflow: 'ellipsis',
      //       }}
      //     >
      //       {loggedInUser.name}
      //     </span>
      //   </AccordionSummary>
      //   <AccordionDetails className={styles.footerDetails}>
      //     <List className={styles.footerList}>
      //       <ListItem button key="logout" onClick={onLogOut}>
      //         <ListItemText primary="Log Out" />
      //       </ListItem>
      //     </List>
      //   </AccordionDetails>
      // </Accordion>
    );
  }

  function renderMobileNavigation(authProperties, navigationProperties) {
    const { title } = navigationProperties;
    // const LogoComponent = logo;

    return (
      <Hidden mdUp implementation="css">
        <AppBar position="fixed" className={styles.appBar}>
          <Toolbar>
            <IconButton
              color="inherit"
              onClick={onChangeMobileNavigation}
              className={styles.iconButton}
            >
              <MenuIcon />
            </IconButton>
            <div style={{
              padding: '14px 20px 14px 10px',
            }}>
              <img src="https://amazingco-static.s3.ap-southeast-2.amazonaws.com/singularity/static/v2/Logo/Side-Lockup-new.png?format=300w" alt="AmazingCo Logo" 
              style={{
                height: '60px'
              }}/>
            </div>
            <Typography variant="h5" noWrap>
              {title}
            </Typography>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="temporary"
          open={isMobileAndOpened}
          onClose={onChangeMobileNavigation}
          className={styles.drawer}
          classes={{
            paper: styles.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {renderNavigationItems(navigationProperties, true)}
          {renderMobileNavigationFooterPanel(authProperties)}
        </Drawer>
      </Hidden>
    );
  }

  return (
    <nav className={styles.root} style={{width: isLabelHidden ? `64px` : `240px`}}>
      {renderDesktopNavigation(authProperties, navigationProperties)}
      {renderMobileNavigation(authProperties, navigationProperties)}
    </nav>
  );
}

Navigation.propTypes = {
  authProperties: PropTypes.object.isRequired,
  navigationProperties: PropTypes.object.isRequired,
};

Navigation.defaultProps = {};

export default Navigation;